import CustomList from "components/list/custom";
import { AmountCell2 } from "@/modules/work/billables/cells";
import { EmployeeCell } from "components/cell/employee/cell";
import { Link } from "react-router-dom";
import { ROUTE } from "@/lib/utils";

export function HighValueProjects() {
  const columns = [
    {
      accessorKey: "name",
      header: "Project",
      cell: ({ getValue, row }) => {
        const projectName = getValue();
        const projectId = row.original.slug;

        return (
          <Link className="hover:underline" to={ROUTE.PROJECT(projectId)}>
            {projectName}
          </Link>
        );
      },
    },
    {
      accessorKey: "no_of_billables",
      header: "No. of Billables",
    },
    {
      accessorKey: "expected_billing",
      header: "Expected Billing",
      cell: AmountCell2,
    },
    {
      accessorKey: "account_manager",
      header: "AM",
      cell: EmployeeCell,
    },
    {
      accessorKey: "sales_coordinator",
      header: "SC",
      cell: EmployeeCell,
    },
  ];

  return (
    <CustomList
      title="High-value projects"
      info="Top 7 projects with highest expected billing (excluding billed, cancelled & collected billables with billing date within 3 months)."
      endPoint="custom-ui/get-high-value-projects"
      columns={columns}
      hidePagination={true}
    />
  );
}
